import { Controller } from "@hotwired/stimulus"
import "./component.scss"

export default class extends Controller {
  static targets = ["navigation", "activeItem"]

  connect() {
    requestAnimationFrame(() => this.scrollActiveItemIntoView())
  }

  scrollActiveItemIntoView() {
    if (!this.hasActiveItemTarget) return

    const navigation = this.navigationTarget
    const item = this.activeItemTarget
    const navigationRect = navigation.getBoundingClientRect()
    const itemRect = item.getBoundingClientRect()
    const gutter = 16

    const isOverflowingLeft = itemRect.left < navigationRect.left + gutter
    const isOverflowingRight = itemRect.right > navigationRect.right - gutter

    if (isOverflowingLeft || isOverflowingRight) {
      item.scrollIntoView({ behavior: "instant", block: "nearest", inline: "center" })
    }
  }
}
